// src/contexts/ConfigContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

// Дефолтные настройки (пока грузится)
const defaultConfig = {
    businessName: "Загрузка...",
    minOrderAmount: 0,
    deliveryCost: 0,
    maxBonusPercent: 30, // <--- Добавили дефолт
    paymentSystem: "none",
    pickupAddress: "",
    contact: {
        phone: "",
        support: ""
    },
    isLoading: true
};

const ConfigContext = createContext(defaultConfig);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(defaultConfig);

    useEffect(() => {
        // Загружаем настройки с API
        fetch('/api/delivery-settings')
            .then(res => res.json())
            .then(data => {
                console.log("Settings loaded:", data); // Для отладки
                setConfig({
                    businessName: data.business_name || "Moyoo Bot",
                    minOrderAmount: Number(data.min_order_amount) || 0,
                    deliveryCost: Number(data.delivery_cost) || 0,
                    // ВАЖНО: Теперь мы сохраняем процент бонусов из API!
                    maxBonusPercent: Number(data.max_bonus_percent) || 30, 
                    paymentSystem: data.payment_system || "none",
                    pickupAddress: data.pickup?.address || "",
                    contact: data.contact || {},
                    isLoading: false
                });
            })
            .catch(err => {
                console.error("❌ Failed to load config:", err);
                setConfig(prev => ({ ...prev, isLoading: false }));
            });
    }, []);

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);
